<template>
  <div class="post-header">
    <div style="display: flex;align-items: center">
      <img style="width: 20px;height: 20px" src="https://img.aixuejie.cn/axj_web_file/icon/WechatIMG123.png">
    </div>
    <div class="axj-main-body-page-info">
      资讯·张贴
    </div>
    <div class="axj-main-body-group">
<!--      <el-button-group>-->
<!--        <el-button size="mini" type="primary">上一页</el-button>-->
<!--        <el-button size="mini" type="primary">下一页</el-button>-->
<!--      </el-button-group>-->
      <el-radio-group size="mini" @change="handlePostTypeChange" v-model="postType">
        <el-radio-button label="院校张贴"></el-radio-button>
        <el-radio-button label="部门张贴"></el-radio-button>
      </el-radio-group>
    </div>
    <div @click="handleCreate" class="axj-main-body-create">
      <button>
        <span class="icon">+</span><span class="text">发布</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "post-header",
  methods:{
    handleCreate(){
      this.$emit("create")
    },
    handlePostTypeChange(){
      this.$emit('post-type-change',this.postType)
    }
  },
  data(){
    return{
      postType:'院校张贴'
    }
  }
}
</script>

<style slot-scope lang="scss">
.post-header {
  margin-bottom: 3px;
  height: 37.98px;
  display: flex;
  width: 100%;
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #FFF;
    background-color: #41555d;
    border-color: #41555d;
    -webkit-box-shadow: -1px 0 0 0 #41555d;
    box-shadow: -1px 0 0 0 #41555d;
  }
  .axj-main-body-create {
    margin-left: auto;
    display: flex;
    button {
      margin: 0;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none;
      font-size: 14.6px;
      width: 101.25px;
      color: #ffffff;
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      //line-height: 48.186px;
      border-radius: 5px;
      letter-spacing: 0.046em;
      background: #00ADB5;
      display: flex;
      font-size: 20.45px;
      align-items: center;
      justify-content: center;
      span[class=text]{
        //line-height: 0;
        position: relative;
      }
      span[class=icon]{
        //line-height: 0;
        font-size: 35.6px;
      }
    }
  }
  .axj-main-body-group{
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
  .axj-main-body-page-info{
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: normal;
    font-size: 17.53px;
    line-height: 225.3%;
    margin-left: 10px;
    /* identical to box height, or 53px */
    color: #41555D;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/component/post-header/index.vue